module.exports = __webpack_public_path__ + "static/img/LA@2x.416c9b53.jpg";